<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="areaMasterMain">
          <project-asset v-on:project-changed="onProjectChange" v-on:vessel-changed="onVesselChange"></project-asset>
          <v-card id="areaMasterCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t("nav.areaMaster") }}</v-card-title>
            <v-data-table id="areaMasterTable" :headers="headers" :items="items" :items-per-page="10" class="elevation-0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: right">{{ props.item.areaID }}</td>
                  <td style="text-align: left">{{ props.item.projectName }}</td>
                  <td style="text-align: left">{{ props.item.vesselName }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: center">{{ props.item.fromKP }}</td>
                  <td style="text-align: center">{{ props.item.toKP }}</td>
                  <td style="text-align: left">{{ props.item.soilName }}</td>
                  <td style="text-align: left">{{ props.item.protectionLevel }}</td>
                  <td style="text-align: left">{{ props.item.undrainedShearStrength }}</td>
                  <td style="text-align: left">{{ props.item.waterDensity }}</td>
                  <td style="text-align: left">{{ props.item.basSection }}</td>
                  <td style="text-align: left">{{ props.item.proposedTrencherName }}</td>
                  <td style="text-align: left">{{ props.item.nozzleConfiguration }}</td>
                  <td style="text-align: left">{{ props.item.averageTrenchingSpeed }}</td>
                  <td style="text-align: left">{{ props.item.targetDoB }}</td>
                  <td style="text-align: left">{{ props.item.towForce }}</td>

                  <td style="text-align: center">
                    <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)"> <v-icon small color="primary">mdi-delete</v-icon> </v-btn>&nbsp;
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted === true" @click="editItem(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="65%">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field v-model="editedItem.areaID" :rules="[() => !!editedItem.areaID || requiredMessage]" required tabindex="1" :readonly="editedIndex > -1">
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("nav.areaMasterId") }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-select :rules="[() => !!editedItem.projectId || requiredMessage]" required :items="projects" item-text="Name" item-value="Id" v-model="editedItem.projectId" :readonly="editedIndex != -1" @change="onDlgProjectChange" tabindex="2">
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("common.projectName") }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select :rules="[() => !!editedItem.vesselId || requiredMessage]" class="form-control" :items="projectVessels" item-text="Name" item-value="Id" v-model="editedItem.vesselId" :readonly="editedIndex != -1" @change="onDlgVesselChange" tabindex="3">
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("common.asset") }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.fromKP" label="area.fromKP" tabindex="6"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.toKP" label="area.toKP" tabindex="7"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.description" :rules="[() => !!editedItem.description || requiredMessage]" required tabindex="4">
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("column.description") }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select class="form-control" :items="soilTypes" item-text="description" item-value="id" v-model="editedItem.soilId" :rules="[() => !!editedItem.soilId || requiredMessage]" required tabindex="8">
                            <template v-slot:label>{{ $t("area.typeOfSoil") }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.protectionLevel" label="area.protectionLevel" tabindex="9"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.undrainedShearStrength" label="area.undrainedShearStrength" tabindex="10"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.waterDensity" label="area.waterDensity" tabindex="11"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.basSection" label="area.basSection" tabindex="12" :is-readonly="true"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select class="form-control" :items="trencher" item-text="description" item-value="id" :reduce="(trencher) => trencher.id" v-model="editedItem.proposedTrencherId" tabindex="13">
                            <template v-slot:label>{{ $t("area.proposedTrencher") }}</template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field v-model="editedItem.nozzleConfiguration" tabindex="14">
                            <template v-slot:label>{{ $t("area.nozzleConfiguration") }}</template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.averageTrenchingSpeed" label="area.averageTrenchingSpeed" tabindex="15"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.targetDoB" decimals :no-decimals="2" label="area.targetDoB" tabindex="16"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.towForce" label="area.towForce" tabindex="17"></positive-numeric-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{ $t("common.cancel") }}</v-btn>
                  <v-btn color="primary" text @click="save" :disabled="!formIsValid" tabindex="18">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn id="btnAddareaMaster" color="primary" dark small left fab @click="createItem()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>

              <v-btn class="ml-5" color="primary" @click="dialogImport = !dialogImport">
                <span class="text-caption">{{ $t("common.importFile") }}</span>
                <v-icon class="ml-3">mdi-microsoft-excel</v-icon>
              </v-btn>
              <v-btn class="ml-5" color="success" :href="exportExcel()" :disabled="disabledExportBtn" @click="mShowInfoMessage('Excel export requested')">
                <span class="text-caption">{{ $t("common.exportFile") }}</span>
                <v-icon class="ml-3">mdi-download</v-icon>
              </v-btn>
            </v-card-actions>

            <v-dialog v-model="dialogImport" persistent width="500">
              <v-card>
                <v-card-title
                  ><span class="headline">{{ $t("common.importFile") }}</span></v-card-title
                >

                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-select :rules="[() => !!importDlg.projectId || requiredMessage]" required :items="projects" item-text="Name" item-value="Id" v-model="importDlg.projectId" :readonly="editedIndex != -1" @change="onDlgImportProjectChange"
                        ><template v-slot:label>
                          <v-icon color="red" x-small>mdi-asterisk</v-icon>
                          {{ $t("common.projectName") }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select :rules="[() => !!importDlg.vesselId || requiredMessage]" required class="form-control" :items="projectVesselsImport" item-text="Name" item-value="Id" v-model="importDlg.vesselId" :readonly="editedIndex != -1" @change="onDlgimportVesselChange">
                        <template v-slot:label>
                          <v-icon color="red" x-small>mdi-asterisk</v-icon>
                          {{ $t("common.asset") }}
                        </template>
                      </v-select></v-col
                    >
                    <v-col cols="12">
                      <v-file-input v-model="file" accept=".xlsx" prepend-icon="mdi-microsoft-excel" label="Choose file to import" class="ma-2" @change="onFilePicked"></v-file-input>
                      <span v-if="showError" style="color: red">{{ $t("common.fileformaterror") }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-checkbox class="ml-3" v-model="emptyFolder">
                        <template v-slot:label>
                          {{ $t("common.emptyFolder") }}
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="warning" text @click="dialogImport = !dialogImport">{{ $t("common.cancel") }}</v-btn>

                  <v-btn color="primary" text :disabled="canUpload" @click="actionUpload()">{{ $t("common.import") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import ProjectAsset from "../common/ProjectAsset";
import Vue from "vue";

export default {
  components: {
    "project-asset": ProjectAsset,
  },
  data() {
    return {
      numberRule: (v) => {
        if (!v || !("" + v).trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return "This field accepts pozitive numbers only!";
      },
      dialog: false,
      requiredMessage: this.$t("common.required"),
      headers: [
        {
          text: this.$t("nav.areaMasterId"),
          align: "right",
          sortable: true,
          value: "areaID",
        },
        {
          text: this.$t("common.projectName"),
          align: "left",
          value: "projectId",
        },
        {
          text: this.$t("common.asset"),
          align: "left",
          value: "vesselId",
        },
        {
          text: this.$t("column.description"),
          align: "left",
          value: "description",
        },
        { text: this.$t("area.fromKP"), align: "center", value: "fromKP" },
        { text: this.$t("area.toKP"), align: "center", value: "toKP" },
        { text: this.$t("area.typeOfSoil"), align: "left", value: "soilId" },
        {
          text: this.$t("area.protectionLevel"),
          align: "left",
          value: "protectionLevel",
        },
        {
          text: this.$t("area.undrainedShearStrength"),
          align: "left",
          value: "undrainedShearStrength",
        },
        {
          text: this.$t("area.waterDensity"),
          align: "left",
          value: "waterDensity",
        },
        {
          text: this.$t("area.basSection"),
          align: "left",
          value: "basSection",
        },
        {
          text: this.$t("area.proposedTrencher"),
          align: "left",
          value: "proposedTrencherId",
        },
        {
          text: this.$t("area.nozzleConfiguration"),
          align: "center",
          value: "nozzleConfiguration",
        },
        {
          text: this.$t("area.averageTrenchingSpeed"),
          align: "center",
          value: "averageTrenchingSpeed",
        },
        {
          text: this.$t("area.targetDoB"),
          align: "center",
          value: "targetDoB",
        },
        { text: this.$t("area.towForce"), align: "center", value: "towForce" },

        {
          text: this.$t("column.actions"),
          align: "center",
          value: "areaMasteractions",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null,

      dialogImport: false,
      showError: false,
      file: null,
      emptyFolder: false,
      selectedPvId: null,
      importDlg: {
        projectId: null,
        vesselId: null,
      },
      excellink: "area/export?pvId=",
    };
  },
  computed: {
    ...mapGetters(["m_area/getAreas", "getProjectVesselMappings", "m_area/getNextSeqCode", "m_area/getBusSeqCode", "m_soil/getSoils", "m_trencher/getTrenchers", "m_project/getProjectNames", "m_project/getProjectsMap", "m_project/getProjectVesselIds", "m_vessel/getVesselNames", "m_vessel/getVesselsMap", "m_passet/getSelProjectId", "m_passet/getSelVesselId", "m_passet/getSelProjectVesselIds"]),
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("nav.areaMaster") : this.$t("common.edit") + " " + this.$t("nav.areaMaster");
    },
    items() {
      return this["m_area/getAreas"];
    },

    projects() {
      return this["m_project/getProjectNames"].filter((p) => p.VCount > 0);
    },

    vessels() {
      return this["m_vessel/getVesselNames"];
    },

    projectVessels() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.dlgSelProjectId) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },

    projectVesselsImport() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.selectedPrj) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },

    trencher() {
      return this["m_trencher/getTrenchers"];
    },

    soilTypes() {
      return this["m_soil/getSoils"];
    },

    formIsValid() {
      return this.editedItem.areaID && this.editedItem.description && this.editedItem.soilId;
    },

    canUpload() {
      return !this.file && !this.showError && !this.selectedPrj && !this.selectedVessel;
    },

    selectedPrj() {
      return this.importDlg.projectId;
    },

    selectedVessel() {
      return this.importDlg.vesselId;
    },

    disabledExportBtn() {
      return this.selVesselId ? (this.selProjectId ? false : true) : true;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },

    selectedPrj: async function() {
      if (this.selectedPrj && this.selectedVessel) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selectedPrj && pv.vesselId == this.selectedVessel);
      }
    },

    selectedVessel: async function() {
      if (this.selectedPrj && this.selectedVessel) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selectedPrj && pv.vesselId == this.selectedVessel);
      }
    },

    selVesselId: async function() {
      if (this.selProjectId && this.selVesselId) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selProjectId && pv.vesselId == this.selVesselId);
      } else this.selectedPvId = null;
    },

    selProjectId: async function() {
      if (this.selProjectId && this.selVesselId) {
        await this.fetchProjectVesselMappings();
        this.selectedPvId = this["getProjectVesselMappings"].filter((pv) => pv.projectId == this.selProjectId && pv.vesselId == this.selVesselId);
      } else this.selectedPvId = null;
    },
  },

  created() {
    this.selProjectId = this["m_passet/getSelProjectId"];
    this.selVesselId = this["m_passet/getSelVesselId"];

    this.defaultItem.projectId = this["m_passet/getSelProjectId"];
    this.defaultItem.vesselId = this["m_passet/getSelVesselId"];

    this.refreshAreas();
    this.refreshNextSeqCode();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader", "mShowInfoMessage"]),
    ...mapActions(["m_area/createArea", "m_area/fetchAreas", "m_area/updateAreaList", "fetchProjectVesselMappings", "m_area/fetchNextMaxCode", "m_area/fetchMaxValues", "m_area/updateArea", "m_area/deleteArea", "m_trencher/fetchTrenchers", "m_soil/fetchSoils", "m_project/fetchProjectVesselNames"]),

    refreshAreas() {
      this["m_area/fetchAreas"]({
        pId: this.selProjectId,
        vId: this.selVesselId,
      });
    },

    refreshDependencies(pId, vId) {
      let pv = {
        pId: pId,
        vId: vId,
        active: 1,
      };

      this.$log.debug("refreshing dependencies", pv);

      this["m_trencher/fetchTrenchers"](pv);
      this["m_soil/fetchSoils"](pv);
    },

    onProjectChange(value) {
      this.selProjectId = value;
      this.refreshAreas();
    },
    onVesselChange(value) {
      this.selVesselId = value;
      this.refreshAreas();
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId;
      Vue.$log.debug("dlg project change", this.dlgSelProjectId);

      this["m_project/fetchProjectVesselNames"](this.dlgSelProjectId);

      //this.editedItem.vesselId = null
      this.refreshNextSeqCode();
    },

    onDlgVesselChange() {
      this.$log.debug("dlg vessel changed", this.editedItem.vesselId);
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return;
      }

      this.refreshNextSeqCode();
    },

    onDlgImportProjectChange() {
      this["m_project/fetchProjectVesselNames"](this.selectedPrj);
    },

    onDlgimportVesselChange() {
      if (!this.selectedPrj || !this.selectedVessel) {
        return;
      }
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false;
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId;
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId;
      this.$log.debug("refresh next max code", pId, vId);

      this.refreshDependencies(pId, vId);

      this["m_area/fetchMaxValues"]({
        pId: pId,
        vId: vId,
      }).then((maxValues) => {
        this.editedItem.areaID = maxValues.areaID;
        this.editedItem.basSection = maxValues.basSection;
        this.editedItem.fromKP = maxValues.fromKP;
        this.$nextTick(() => this.$forceUpdate());
      });
    },

    resetEntity(item) {
      this.dlgSelProjectId = null;
      this["m_project/fetchProjectVesselNames"](this.dlgSelProjectId);

      this.defaultItem.projectId = this["m_passet/getSelProjectId"];
      this.defaultItem.vesselId = this["m_passet/getSelVesselId"];

      this.editedIndex = item ? this.items.indexOf(item) : -1;
      this.editedItem = Object.assign({}, item || this.defaultItem);
    },

    editItem(item) {
      this.resetEntity(item);
      this.onDlgProjectChange();

      this.refreshDependencies(this.editedItem.projectId, this.editedItem.vesselId);
      this.dialog = true;
    },

    createItem() {
      this.resetEntity();

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange();
      }

      this.refreshNextSeqCode();
      this.dialog = true;
    },

    deleteItemConfirm(item) {
      this.resetEntity(item);
      var msg = this.editedItem.isDeleted ? "warming.unlock" : "warming.lock";

      this.$confirm(this.$t(msg) + this.$t("nav.areaMaster") + "?", {
        buttonTrueText: this.$t("common.ok"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => res && this["m_area/deleteArea"](this.editedItem).then(this.refreshAreas));
    },

    close() {
      this.$refs.form.resetValidation();
      this.dialog = false;
    },

    save() {
      if (~this.editedIndex) {
        this["m_area/updateArea"](this.editedItem).then(this.refreshAreas);
      }

      if (!~this.editedIndex) {
        this["m_area/createArea"](this.editedItem).then(this.refreshAreas);
      }

      this.close();
    },

    onFilePicked() {
      this.$log.debug(this.file);
      let sp = this.file.name.split(".");
      if (this.file) {
        if (sp[1] != "xlsx") {
          this.showError = true;
        } else this.showError = false;
      }
    },

    exportExcel() {
      let pvId = this.selectedPvId ? this.selectedPvId[0].id : "";
      if (this.excellink) return Vue.$hrefWithParams(this.excellink + pvId);
      return undefined;
    },

    async actionUpload() {
      let payload = {
        pvId: this.selectedPvId[0].id,
        file: this.file,
        resetOldValues: this.emptyFolder,
      };

      await this["m_area/updateAreaList"](payload)
        .then(this.refreshAreas)
        .then((this.dialogImport = false));
    },
  },
};
</script>

<style>
#areaMasterTable {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  width: auto;
  height: auto;
}
#areaMasterTable header {
  font-weight: bold;
}
#areaMasterCard {
  width: auto;
}
</style>
